<template>
  <div class="sport" :class="{ open: open }">
    <div class="sport-hat" :class="{ active: !isActive('view', 'main') && $route.params.sport == sport.id }">
      <active-button
        class="sport-button"
        line-color="blue"
        line-position="left"
        :active="!isActive('view', 'main') && $route.params.sport == sport.id"
        @click="$router.push(`/live/sport/${sport.id}`)"
      >
        <sport-icon-liga-white :class="{ activeSport: !isActive('view', 'main') && $route.params.sport == sport.id }" :name="sport.alias" ></sport-icon-liga-white>
        <div class="sport-name ellipsis">{{ sport.name }}</div>
      </active-button>
      <icon-button @click="open = !open">
        <arrow-icon :direction="open ? 'up' : 'down'"></arrow-icon>
      </icon-button>
      <div class="events-count">{{ sport.count_events }}</div>
    </div>
    <div class="list">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import ActiveButton from '@/components/buttons/ActiveButton'
import IconButton from '@/components/buttons/IconButton'
import ArrowIcon from '@/components/icons/ArrowIcon'
import SportIconLigaWhite from '@/components/icons/SportIconLigaWhite'

export default {
  components: {
    ActiveButton,
    IconButton,
    ArrowIcon,
    SportIconLigaWhite
  },
  props: {
    sport: Object
  },
  data () {
    return {
      open: false
    }
  }
}
</script>

<style scoped>
.sport-hat {
  display: flex;
  border-radius: 10px;
  background: white;
  margin-left: 5px;
  margin-right: 10px;
  margin-bottom: 4px;
}
.sport-hat:hover { background: #d4dbe3; }
.sport-hat.active:first-child { border: 1px solid #713592; margin-bottom: 3px; }
.sport-hat.active { border: 1px solid #713592; margin-bottom: 3px; margin-top: -1px;}
.sport-button { display: flex; height: 40px; line-height: 40px; width: 185px;}
.sport-icon-liga-white { margin-left: 10px; margin-top: 8px; }
.sport-name { flex: 1; padding-right: 10px; margin-left: 10px; }
.events-count { flex-shrink: 0; height: 40px; line-height: 40px; text-align: center; width: 40px; margin-right: -0.80px; }
.list { background: rgba(255, 255, 255, .05); display: none; position: relative; }
.open .list { display: block; margin-left: 5px; width: 225px; }
.activeSport { margin-left: 9.20px; }

.sport .icon-button,
.sport:hover .events-count,
.sport.open .events-count { display: none; }
.sport:hover .icon-button,
.sport.open .icon-button { display: flex; }
</style>



// WEBPACK FOOTER //
// src/components/live/menu/Sport.vue